import { useQuery } from "@tanstack/react-query";
import axiosInstance from "./axiosInstanse";
import { enum_api_uri } from "../utils/enum";

interface RequestList {
    list_no: string;
    운송장번호: string;
    NO: number;
    카테고리: string;
    제목: string;
    요청업체명: string;
    연락드릴번호: string;
    등록일: string;
    상태: string;
}

export interface RequestListResponse {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    request_list: RequestList[];
}

export interface RequestListItem {
    getPage: string;
    getPageSize: string;
    category: string;
}

export const usePostRequestList = ({ getPage, getPageSize, category }: { getPage: string; getPageSize: string; category: string }) => {
    return useQuery({
        queryKey: ["usePostRequestList", getPage, getPageSize, category],
        queryFn: async () => {
            const requestData = { getPage, getPageSize, category };
            const response = await axiosInstance.post<{ statusCode: number; message: string; data: RequestListResponse }>(
                enum_api_uri.request_list,
                requestData,
            );
            return response.data.data;
        },
        enabled: !!category,
        placeholderData: prev => prev,
    });
};
